import { autoMedicalClaimsEndpoint } from '../../../../../common/api.endPoints';
import { HttpService } from '../../../../../common/http.service';
import { MedicalClaim, RuleHit } from './types';

export type AutoMedicalClaimsData = {
  ruleHits: RuleHit[];
  claimsById: Record<number, MedicalClaim>;
  independentClaims: MedicalClaim[];
};

type AutoMedicalClaimsResponse = {
  ruleHits?: RuleHit[];
  claims?: MedicalClaim[];
  independentClaims?: MedicalClaim[];
};

export async function fetchAutoMedicalClaims(
  evidenceId: number,
): Promise<AutoMedicalClaimsData> {
  const response = await HttpService.getInstance().get(
    autoMedicalClaimsEndpoint(evidenceId),
  );

  if (response?.error) {
    throw new Error(
      response.error.message ?? 'Failed to fetch auto medical claims',
    );
  }

  const body = response?.parsedBody as AutoMedicalClaimsResponse | undefined;
  const ruleHits = (
    Array.isArray(body?.ruleHits) ? body?.ruleHits : []
  ) as RuleHit[];
  const claims = (
    Array.isArray(body?.claims) ? body?.claims : []
  ) as MedicalClaim[];
  const independentClaims = (
    Array.isArray(body?.independentClaims) ? body?.independentClaims : []
  ) as MedicalClaim[];

  const claimsById: Record<number, MedicalClaim> = {};
  for (const claim of claims) {
    if (claim && typeof claim.id === 'number') {
      claimsById[claim.id] = claim;
    }
  }

  return { ruleHits, claimsById, independentClaims };
}
